import React from "react";
import { motion, cubicBezier } from "framer-motion";

//Data
import { menuData } from "../data/menuData";

//Default transition
const easing = cubicBezier(0.6, 0.01, -0.05, 0.9);
const transition = { duration: 0.8, ease: easing };

const PizzaDrinks = (props) => {
  const { setActiveObject, workingHours, getClass } = props;
  const showItem = (item) => item.isBaseVariant !== false;

  const pizza = menuData.filter(
    (item) => item.category === "pizza" && showItem(item),
  );
  const drinks = menuData.filter(
    (item) => item.category === "drinks" && showItem(item),
  );

  return (
    <>
      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Пица 30цм</span>
      </motion.h4>
      <ul className="list-menu">
        {pizza.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Пиће</span>
      </motion.h4>
      <ul className="list-menu">
        {drinks.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img
              className="list-img"
              src={product.image || "https://idzuo.com/menuImages/Placeholder.png"}
              alt="Ресторан идзуо"
            />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}{product.isNew && <span className="badge-new">novo</span>}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>
    </>
  );
};

export default PizzaDrinks;
